var map = {
	"./coursera-01.png": 95,
	"./datacamp-01.png": 96,
	"./google.png": 97,
	"./google2.jpg": 98,
	"./icl.jpg": 99,
	"./iitg-01.png": 100,
	"./iitg.png": 101,
	"./ineuron-01.png": 102,
	"./lse.png": 103,
	"./paris.png": 104,
	"./problem-01.png": 105,
	"./python-01.png": 106,
	"./simplilearn-01.png": 107,
	"./tabana-01.png": 108,
	"./tabcon-01.png": 109,
	"./udemy-01.png": 110
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94;